import { HTMLAttributes, useEffect, useState } from 'react';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { Typography } from '@mui/material';

type PolicyCardHeaderInsuranceTypeNameViewProps =
  HTMLAttributes<HTMLDivElement> & {
    policy: PolicyModel;
  };
const PolicyCardHeaderInsuranceTypeNameView = (
  props: PolicyCardHeaderInsuranceTypeNameViewProps
) => {
  const { policy } = props;
  const [title, setTitle] = useState('');

  /**
   * effects
   */
  useEffect(() => {
    setTitle(getTitleText());
  }, []);

  /**
   * methods
   */
  const getTitleText = () => {
    if (policy?.isGreateAmerican) {
      return 'Motor Truck Cargo insurance';
    } else {
      return 'Business insurance';
    }
  };

  return (
    <Typography className="font-black leading-normal" variant="h6">
      {title}
    </Typography>
  );
};

export default PolicyCardHeaderInsuranceTypeNameView;
